<template>
  <div class="">
  <vue-headful
	title="Settings - Select Exchanges"
	description="Select your preferred exchanges."
  />
  <div id="breadcrumb" class="m-1">
  <b-breadcrumb >
  	<b-breadcrumb-item text="Home" />
  	<b-breadcrumb-item text="Settings" />
  	<b-breadcrumb-item text="Exchanges" active/>
  </b-breadcrumb>
  </div>

    <h1>Select Exchanges</h1>

    <p class="lead">
    Select your preferred exchanges so we can provide live pricing information.
    </p>

    <b-card class="mx-auto text-center" header="Loading" v-show="loadingExchanges">
	<h2><i class="fa fa-spinner spin"></i></h2>
	</b-card>

    <!-- Primary Exchange -->

    <!-- Selected Exchanges -->

    <!-- All Exchanges -->

	<b-card class="mx-auto text-center" header="Exchanges" v-show="exchangeList.length > 0">
	<b-row align-h="center" v-show="exchangeList.length > 0" id="exchangeTable">
	<b-container class="">

		<div  v-for="exchange in exchangeList" class="border border-left-0 border-right-0 p-1 m-1" v-show="true">
			<b-row v-on:click="toggleExchange(exchange)" v-bind:class="{ 'text-success': isSelected(exchange)}" class="cursor-pointer">
				<b-col >
					<div>
					<span v-if="isUserExchange(exchange)"><i class="fa fa-star favorite" /></span>
					{{exchange == 'CCCAGG'? 'Average Price (CCCAGG)' : exchange}}
					</div>

				</b-col>


			</b-row>


		</div>
	</b-container>
	</b-row>
	</b-card>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.selectedExchange {
	background-color: #a1ff8e;
}
.favorite { color: gold }
.cursor-pointer {cursor: pointer}
</style>

<script>
export default {
  name: '',
  data () {
    return {
      msg: '',
      exchangeList: [],
      exchanges: {},
      primaryExchange: null,
//      myExchanges: {},
      loadingExchanges: true,

    }
  },

  computed: {
  	// load getters from Vuex state

		myExchanges: function() {
			// load selected exchange list
			return this.$root.$store.getters['CCStore/myExchanges'];
		}
  },

  mounted: function () {

		this.$nextTick(function () {
			// Code that will run only after the
			// entire view has been rendered

//			// restore last profit/loss settings
//			var profitAmount = this.rememberData('profitAmount') || 0;
//			this.$set(this.profitLoss, 'profitAmount', profitAmount);


			this.initializeData();


		});
	},

  methods: {
	  getExchangeList() {
		  // get from state
		  return this.$root.$store.dispatch('CCStore/getExchangeList');
	  },

	  toggleExchange(exchange) {

		  if (this.myExchanges[exchange]) {
//			  this.$delete(this.myExchanges, exchange);
			  return this.$root.$store.commit('CCStore/removeMyExchange', exchange);
		  } else {
//			  this.$set(this.myExchanges, exchange, true);
			  return this.$root.$store.commit('CCStore/addMyExchange', exchange);
		  }

	  },

	  isSelected(exchange) {
		  if (this.myExchanges[exchange]) {
			  return true;
		  }

		  return false;
	  },

	  /**
	   * Returns true if this is a user favorite exchange.
	   */
	  isUserExchange(exchange) {
		  if (this.myExchanges[exchange]) {
			  return true;
		  }
		  return false;
	  },

	  initializeData() {
		  var promisedData = this.getExchangeList();
		  promisedData.then((exchanges) =>{
			  this.exchanges = exchanges; // save entire object

			  var userExchanges = this.myExchanges;

			  function sorter(a, b) {

				  // Is this the Average Price exchange CCCAGG?
				  if (a === "CCCAGG") {
					  return -1;
				  } else if (b === "CCCAGG") {
					  return 1;
				  }

				  // is either one of the user selected exchanges?
				  else if ((userExchanges[a]) || (userExchanges[b])) {

					  if ((userExchanges[a]) && (!userExchanges[b])) {
						  // a is a user exchange so sort it lower
						  return -1;
					  } else if ((!userExchanges[a]) && (userExchanges[b])) {
						  // a is not a user exchange so sort it higher
						  return 1;
					  } else if ((userExchanges[a]) && (userExchanges[b])) {
						  // if both are user exchanges, sort alphabetically
						  return a.localeCompare(b);
					  }

				  }
				  // Everything else sort alphabetically
				  else {
					  return a.localeCompare(b);
				  }
			  }

			  // build an array of exchange names
			  for (var exchange in exchanges) {
				  this.exchangeList.push(exchange);
			  }

			  this.exchangeList.sort(sorter);

			  // Remove loading spinner
			  this.loadingExchanges = false;
		  });
	  }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/SettingsExchanges.vue